import { appFetch, AppFetchResponse } from "../utils/appFetch";
import {FilterProps} from "../components/table/tableTypes";

export const blockCustomer = async (selectedDomain: string, clientId: number, shouldBlock: boolean): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: 'shop-clients/block',
        method: 'PUT',
        headers: {
            "Content-Type": "application/json",
        },
        domain: selectedDomain,
        params: {
            clientId,
            shouldBlock
        }
    });
}